export default "__VITE_ASSET__GAoQjl4g__"